// extracted by mini-css-extract-plugin
var _1 = "Jkute";
export { _1 as "base" }
